import { MaximumBudget, SearchProfileRangeEnum } from "@justhome/api-core";
import { EmploymentType, PropertyType } from "@justhome/api-core";

export enum YesNo {
  yes = "YES",
  no = "NO",
}

export enum BudgetCheckStepId {
  federalState = "federal-state",
  propertyType = "property-type",
  employmentType = "employment-type",
  employedIncome = "employed-income",
  selfEmployedIncome = "self-employed-income",
  retiredIncome = "retired-income",
  equity = "equity",
  contact = "contact",
  result = "result",
  loading = "loading",
}

export interface BudgetCheckFormValues {
  federalState?: MaximumBudget["federalState"];
  hasSpecificProperty?: YesNo;
  employmentType: EmploymentType;
  employmentStart?: string;
  monthlyNetIncome?: number;
  equity: number;
  existingDebt?: number;
  yearlyNetIncome?: number;
  leadId?: string;
  wantsToSellAProperty?: YesNo;
  searchProfile?: SearchProfile;
}

interface SearchProfile {
  placeId: string;
  range: SearchProfileRangeEnum;
  propertyType?: PropertyType | "OTHER";
  squaremeter?: [number, number];
  rooms?: [number, number];
}
